// src/components/ThemeToggle.jsx
import React from 'react';
import { useTheme } from '../context/ThemeContext'; // Make sure this path is correct
import { Sun, Moon } from 'lucide-react';

/**
 * A simple button component that toggles the application's theme between light and dark.
 * It uses the `useTheme` hook to get the current theme and the `toggleTheme` function.
 */
export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors"
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun size={20} className="text-yellow-400" />
      ) : (
        <Moon size={20} className="text-gray-300" />
      )}
    </button>
  );
}